/**
 * klubb-header-search — mobile search toggle.
 *
 * On mobile the search bar is collapsed behind a magnifier icon in the top
 * bar to save header height; this wires that toggle. Desktop always shows
 * the bar (the toggle button is display:none there via CSS), so the
 * open/closed class is inert on desktop.
 */

export function wireSearchToggle(header) {
  // Guard against double-wiring, same convention as the other klubb modules.
  if (header.dataset.klubbSearchWired === 'true') return;
  header.dataset.klubbSearchWired = 'true';

  const btn = header.querySelector('[data-klubb-search-toggle]');
  const form = header.querySelector('.klubb-header__search');
  if (!btn || !form) return;

  btn.addEventListener('click', () => {
    const open = header.classList.toggle('klubb-header--search-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      const input = form.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  });
}

function init() {
  document.querySelectorAll('.klubb-header').forEach((header) => {
    wireSearchToggle(header);
  });
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
